/** Popular geo / language options for Article Generator. */

export const COUNTRY_OPTIONS = [
  "United States",
  "United Kingdom",
  "Canada",
  "Australia",
  "Germany",
  "France",
  "Spain",
  "Italy",
  "Netherlands",
  "Belgium",
  "Austria",
  "Switzerland",
  "Sweden",
  "Norway",
  "Denmark",
  "Finland",
  "Poland",
  "Czech Republic",
  "Portugal",
  "Ireland",
  "Romania",
  "Hungary",
  "Greece",
  "Mexico",
  "Brazil",
  "Argentina",
  "Chile",
  "Colombia",
  "Peru",
  "Japan",
  "South Korea",
  "India",
  "Indonesia",
  "Philippines",
  "Thailand",
  "Vietnam",
  "Malaysia",
  "Singapore",
  "Taiwan",
  "Hong Kong",
  "United Arab Emirates",
  "Saudi Arabia",
  "Israel",
  "Turkey",
  "South Africa",
  "New Zealand",
] as const

export const LANGUAGE_OPTIONS = [
  "English",
  "Spanish (Spain)",
  "Spanish (LATAM)",
  "Portuguese (Brazil)",
  "Portuguese (Portugal)",
  "French",
  "German",
  "Italian",
  "Dutch",
  "Polish",
  "Romanian",
  "Czech",
  "Swedish",
  "Norwegian",
  "Danish",
  "Finnish",
  "Greek",
  "Hungarian",
  "Turkish",
  "Arabic",
  "Hebrew",
  "Japanese",
  "Korean",
  "Chinese (Simplified)",
  "Chinese (Traditional)",
  "Indonesian",
  "Thai",
  "Vietnamese",
  "Hindi",
] as const
